import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  SystemStatusState,
  systemStatusFeatureKey
} from './system-status.state';

export const selectSystemStatusStateRoot =
  createFeatureSelector<SystemStatusState>(systemStatusFeatureKey);

export const selectIssues = createSelector(
  selectSystemStatusStateRoot,
  (state) => state.issues
);

export const selectFeedbacks = createSelector(
  selectSystemStatusStateRoot,
  (state) => state.feedbacks
);

export const selectSystemReports = createSelector(
  selectSystemStatusStateRoot,
  (state) => state.systemReports
);

export const selectSystemReportsStatus = createSelector(
  selectSystemStatusStateRoot,
  (state) => state.systemReportsStatus
);

/**
 * True only when the load actually failed. Deliberately not true while idle or
 * loading, so the page does not flash "unavailable" before the first response.
 */
export const selectSystemReportsUnavailable = createSelector(
  selectSystemReportsStatus,
  (status) => status === 'unavailable'
);

/**
 * True only once a successful load has confirmed there are no published issues.
 * "All Systems Operational" must never be shown on the strength of an empty
 * list alone, because the list is also empty before and after a failure.
 */
export const selectAllSystemsOperational = createSelector(
  selectSystemReportsStatus,
  selectSystemReports,
  (status, reports) => status === 'loaded' && reports.length === 0
);

export const selectLoading = createSelector(
  selectSystemStatusStateRoot,
  (state) => state.loading
);

export const selectAnalytics = createSelector(
  selectSystemStatusStateRoot,
  (state) => state.analytics
);
